import Model from "./base/model";

class OrderInvoice extends Model {
  resourceName() {
    return "order_invoices";
  }

  fields() {
    return {
      number: "",
    };
  }
}

export default new OrderInvoice();
